import type { AgentDetails } from '@atlassian/conversation-assistant-service';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fetchJson } from '@atlassian/jira-fetch';

/**
 * @deprecated Do not use, temporary function to be cleaned up post Team EU 25
 * Fetches agent details by agent ID.
 * Returns AgentDetails if found, otherwise null.
 */
export const fetchAgentDetailsById = async (agentId: string): Promise<AgentDetails | null> => {
	try {
		const headers = {
			'x-experience-id': 'profile-card',
			'x-product': 'jira',
		};

		const url = `/gateway/api/assist/rovo/v1/agents/accountid/${agentId}`;

		const response: AgentDetails = await fetchJson<AgentDetails>(url, {
			method: 'GET',
			headers,
		});

		return response;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		const isClientError = error.status >= 400 && error.status < 500;

		if (!isClientError) {
			fireErrorAnalytics({
				meta: {
					id: 'fetchAgentDetailsById',
					packageName: 'jiraSoftwareBoard',
					teamName: 'crocs',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
		}

		throw error;
	}
};
